import { render, staticRenderFns } from "./UpdateCalendarItemPage.vue?vue&type=template&id=4bc51103&scoped=true&"
import script from "./UpdateCalendarItemPage.vue?vue&type=script&lang=js&"
export * from "./UpdateCalendarItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc51103",
  null
  
)

export default component.exports